'use strict';

const ns = 'pdp-image-zoom';

const $html = $('html');
const $zoom = $(`
    <div class="${ns} js-${ns} ${ns}-uninitialized">
        <div class="${ns}__inner">
            <div class="${ns}__header">
                <div class="${ns}__close js-${ns}__close"></div>
            </div>
            <div class="${ns}__body">
                <div class="${ns}__image-container">
                    <img class="${ns}__image">
                </div>
                <ul class="${ns}__thumbnails product-thumbnails"></ul>
            </div>
        </div>
    </div>
`);
const $zoomContainer = $zoom.find(`.${ns}__body`);
const $zoomImageContainer = $zoom.find(`.${ns}__image-container`);
const $zoomImage = $zoom.find(`.${ns}__image`);
const $zoomThumbnails = $zoom.find(`.${ns}__thumbnails`);
var $outerImgContainer = null;
var $outerThumbnails = null;

const pdpImageZoom = {
    zoomMore(triggeringEvent) {
        // get the clicked coordinates relative to the image prior to zoom
        let originalOffset = $zoomImage.offset();
        let originalWidth = $zoomImage.width();
        let originalHeight = $zoomImage.height();
        let coordinateX = triggeringEvent.pageX - originalOffset.left;
        let coordinateY = triggeringEvent.pageY - originalOffset.top;

        $zoomImageContainer.addClass('zoom-more');
        $zoomImage.addClass('zoom-more');

        // calculate new coordinates based on the zoom image size and adjusted to skew the position towards the center of the image
        let newCoordinateX = (coordinateX * ($zoomImage.width() / originalWidth)) / 1.5;
        let newCoordinateY = (coordinateY * ($zoomImage.height() / originalHeight)) / 1.5;

        if ($zoomImageContainer.hasClass('draggable')) {
            // position the clicked part of the image to the center of the container
            $zoomImage.css('top', `${0 - newCoordinateY}px`);
            $zoomImage.css('left', `${0 - newCoordinateX}px`);
        } else {
            // scroll the container until the clicked part of the image is at the center of the container
            $zoomImageContainer.scrollTop(newCoordinateY);
            $zoomImageContainer.scrollLeft(newCoordinateX);
        }
    },
    resetZoom() {
        $zoomImageContainer.removeClass('zoom-more');
        $zoomImage.removeClass('zoom-more');
    },
    setZoomImg($zoomTarget) {
        let hiresUrl = $zoomTarget.data('href-hires') || $zoomTarget.attr('href');
        let alt = $zoomTarget.find('img').attr('alt');
        if (!hiresUrl) {
            let $images = $zoomTarget.closest(`.js-${ns}`).find('.js-pdp-sliders__main');
            let $altTarget = $images.find(`.slick-current .js-${ns}__target`);
            if ($altTarget.length === 0) {
                //  No slick. Single image.
                $altTarget = $images.find(`.js-${ns}__target`);
            }
            hiresUrl =  $altTarget.data('href-hires') || $altTarget.attr('href');
            alt = $($altTarget).find('img').attr('alt');
        }
        $html.addClass(`is-${ns}-loading`);
        $zoomImage.attr('src', hiresUrl);
        $zoomImage.attr('alt', `${alt} hi-res`);
    },
    setThumbnails($zoomTarget) {
        $zoomThumbnails.html('');
        // copy thumbnails to zoom container
        $outerImgContainer = $zoomTarget.parents('.product-image-container');
        if ($outerImgContainer.length > 0) {
            $outerThumbnails = $outerImgContainer.find('.product-thumbnails .thumb');
            if ($outerThumbnails.length > 0) {
                $outerThumbnails.each((index, el) => {
                    let $thumb = $(el).clone();
                    $thumb.attr('style', ''); // remove inline styles
                    $zoomThumbnails.append($thumb);
                });
            }
        }
    },
    initDraggable() {
        if (typeof matchMedia === 'function' && matchMedia('(pointer:fine)').matches) {
            // only if device has mouse support, add draggable
            $zoomImage.draggable({
                scroll: true
            });
            $zoomImageContainer.addClass('draggable');
        }
    },
    init() {
        if ($zoom.hasClass(`${ns}-initialized`) || $zoom.hasClass(`${ns}-initializing`)) {
            return;
        }
        $zoom.addClass(`${ns}-initializing`).removeClass(`${ns}-uninitialized`);
        $('body')
        .on('click', `.js-${ns}__target`, e => {
            e.preventDefault();
            let $target = $(e.currentTarget);
            pdpImageZoom.setZoomImg($target);
            pdpImageZoom.setThumbnails($target);
            pdpImageZoom.initDraggable();
        })
        .on('click', `.js-${ns}`, e => {
            e.preventDefault();
            e.stopImmediatePropagation();
            let $target = $(e.target);
            if ($target.is(`.${ns}__thumbnails *`)) {
                $target = $target.hasClass('thumb') ? $target : $target.closest(`.thumb`);
                if ($target.length && !$target.hasClass('selected')) {
                    let $zoomTarget = $outerImgContainer.find('.js-pdp-image-zoom__target[data-image-index="' + $target.data('image-index') + '"]');
                    if ($zoomTarget.length) {
                        pdpImageZoom.resetZoom();
                        pdpImageZoom.setZoomImg($zoomTarget);
                        $(`.${ns}__thumbnails .thumb`).removeClass('selected');
                        $target.addClass('selected');
                    }
                }
            } else if ($target.is(`.${ns}__image`) || $target.is(`.${ns}__image-container`)) {
                if ($target.hasClass('zoom-more')) {
                    pdpImageZoom.resetZoom();
                } else {
                    pdpImageZoom.zoomMore(e);
                }
            } else if ($target.hasClass(`${ns}__close`) || (window.innerWidth >= 768 && $target.is(`.is-${ns}-active *`) && $target.parents(`.pdp-image-zoom__inner`).length === 0)) {
                pdpImageZoom.close();
            }
        })
        .append($zoom);

        $zoomImage.load(e => {
            $html.addClass(`is-${ns}-active`).removeClass(`is-${ns}-loading`);
        });

        $(document).keyup(e => {
            if (e.keyCode === 27) { // esc
                pdpImageZoom.close();
            }
        });
        $zoom.addClass(`${ns}-initialized`).removeClass(`${ns}-initializing`);
    },

    close() {
        pdpImageZoom.resetZoom();
        $html.removeClass(`is-${ns}-active`);
        $zoomImage.attr({
            src: '',
            srcset: ''
        });
    }

};

module.exports = pdpImageZoom;
